import { useState } from "react";
import "./editorialForms.css";

const postTypes = [
  { id: "appointment", name: "Consulta/Agendamento" },
  { id: "prescription", name: "Receita" },
  { id: "exam", name: "Exame" },
  { id: "tip", name: "Dica de Saúde" },
  { id: "professional", name: "Perfil Profissional" },
];

const specialties = [
  "Cardiologia",
  "Dermatologia",
  "Endocrinologia",
  "Gastroenterologia",
  "Ginecologia",
  "Neurologia",
  "Oftalmologia",
  "Ortopedia",
  "Pediatria",
  "Psiquiatria",
  "Urologia",
  "Clínico Geral",
  "Odontologia",
  "Fisioterapia",
  "Nutrição",
  "Psicologia",
  "Outra",
];

export default function MedicalForm({ data, onChange }) {
  const [insuranceInput, setInsuranceInput] = useState("");
  const [slotDate, setSlotDate] = useState("");
  const [slotTime, setSlotTime] = useState("");

  const handleAddInsurance = () => {
    if (insuranceInput.trim()) {
      onChange({
        ...data,
        acceptsInsurance: [...(data?.acceptsInsurance || []), insuranceInput.trim()],
      });
      setInsuranceInput("");
    }
  };

  const handleRemoveInsurance = (index) => {
    onChange({
      ...data,
      acceptsInsurance: (data?.acceptsInsurance || []).filter((_, i) => i !== index),
    });
  };

  const handleAddSlot = () => {
    if (slotDate && slotTime) {
      onChange({
        ...data,
        availableSlots: [
          ...(data?.availableSlots || []),
          { date: slotDate, time: slotTime, available: true },
        ],
      });
      setSlotDate("");
      setSlotTime("");
    }
  };

  const handleRemoveSlot = (index) => {
    onChange({
      ...data,
      availableSlots: (data?.availableSlots || []).filter((_, i) => i !== index),
    });
  };

  return (
    <div className="editorial_form medical_form">
      <div className="editorial_form_section">
        <label>Tipo de Publicação</label>
        <select
          value={data?.type || ""}
          onChange={(e) => onChange({ ...data, type: e.target.value })}
        >
          <option value="">Selecione</option>
          {postTypes.map((type) => (
            <option key={type.id} value={type.id}>
              {type.name}
            </option>
          ))}
        </select>
      </div>

      <div className="editorial_form_section">
        <label>
          Título <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Ex: Consulta com Cardiologista, Dica de Saúde..."
          value={data?.title || ""}
          onChange={(e) => onChange({ ...data, title: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>Descrição</label>
        <textarea
          placeholder="Detalhes, informações importantes..."
          value={data?.description || ""}
          onChange={(e) => onChange({ ...data, description: e.target.value })}
          maxLength={2000}
          rows={3}
        />
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Especialidade</label>
          <select
            value={data?.specialty || ""}
            onChange={(e) => onChange({ ...data, specialty: e.target.value })}
          >
            <option value="">Selecione</option>
            {specialties.map((spec) => (
              <option key={spec} value={spec}>
                {spec}
              </option>
            ))}
          </select>
        </div>

        <div className="editorial_form_section">
          <label>Valor da Consulta (R$)</label>
          <input
            type="number"
            placeholder="0.00"
            value={data?.consultationPrice || ""}
            onChange={(e) =>
              onChange({
                ...data,
                consultationPrice: parseFloat(e.target.value) || 0,
              })
            }
            min="0"
            step="0.01"
          />
        </div>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Nome do Profissional</label>
          <input
            type="text"
            placeholder="Dr(a). Nome Completo"
            value={data?.professionalName || ""}
            onChange={(e) =>
              onChange({ ...data, professionalName: e.target.value })
            }
          />
        </div>

        <div className="editorial_form_section">
          <label>CRM/Registro</label>
          <input
            type="text"
            placeholder="CRM 123456"
            value={data?.professionalCRM || ""}
            onChange={(e) =>
              onChange({ ...data, professionalCRM: e.target.value })
            }
          />
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Clínica/Hospital</label>
        <input
          type="text"
          placeholder="Nome da clínica ou hospital"
          value={data?.clinic || ""}
          onChange={(e) => onChange({ ...data, clinic: e.target.value })}
        />
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Endereço</label>
          <input
            type="text"
            placeholder="Rua, número, bairro"
            value={data?.address || ""}
            onChange={(e) => onChange({ ...data, address: e.target.value })}
          />
        </div>

        <div className="editorial_form_section">
          <label>Telefone</label>
          <input
            type="tel"
            placeholder="(11) 99999-9999"
            value={data?.phone || ""}
            onChange={(e) => onChange({ ...data, phone: e.target.value })}
          />
        </div>
      </div>

      <div className="editorial_form_section">
        <div className="editorial_form_checkbox">
          <input
            type="checkbox"
            id="isTelemedicine"
            checked={data?.isTelemedicine || false}
            onChange={(e) =>
              onChange({ ...data, isTelemedicine: e.target.checked })
            }
          />
          <label htmlFor="isTelemedicine">Atende por telemedicina</label>
        </div>
      </div>

      <div className="editorial_form_section">
        <label>
          Convênios Aceitos
          <button
            type="button"
            className="add_variant_btn"
            onClick={handleAddInsurance}
          >
            + Adicionar
          </button>
        </label>
        <input
          type="text"
          placeholder="Ex: Unimed, Bradesco Saúde..."
          value={insuranceInput}
          onChange={(e) => setInsuranceInput(e.target.value)}
          onKeyPress={(e) => e.key === "Enter" && handleAddInsurance()}
        />
        <div className="genre_chips" style={{ marginTop: "8px" }}>
          {(data?.acceptsInsurance || []).map((insurance, i) => (
            <span
              key={i}
              className="genre_chip selected"
              onClick={() => handleRemoveInsurance(i)}
              style={{ cursor: "pointer" }}
            >
              {insurance} ×
            </span>
          ))}
        </div>
      </div>

      {(data?.type === "appointment" || data?.type === "professional") && (
        <div className="editorial_form_section">
          <label>
            Horários Disponíveis
            <button
              type="button"
              className="add_variant_btn"
              onClick={handleAddSlot}
            >
              + Adicionar
            </button>
          </label>
          <div className="editorial_form_row" style={{ marginBottom: "8px" }}>
            <input
              type="date"
              value={slotDate}
              onChange={(e) => setSlotDate(e.target.value)}
            />
            <input
              type="time"
              value={slotTime}
              onChange={(e) => setSlotTime(e.target.value)}
            />
          </div>
          <div className="genre_chips">
            {(data?.availableSlots || []).map((slot, i) => (
              <span
                key={i}
                className="genre_chip selected"
                onClick={() => handleRemoveSlot(i)}
                style={{ cursor: "pointer" }}
              >
                {new Date(slot.date).toLocaleDateString("pt-BR")} às {slot.time} ×
              </span>
            ))}
          </div>
        </div>
      )}

      <div className="editorial_form_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M19 3H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 11h-4v4h-4v-4H6v-4h4V6h4v4h4v4z" />
        </svg>
        <span>
          Compartilhe informações de saúde confiáveis e ajude a comunidade.
        </span>
      </div>
    </div>
  );
}
